import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { queryKeys } from "@/lib/api/queryKeys";
import { API_ENDPOINTS } from "@/lib/config/constants";

export function useEtatDemande(code: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.collections.etatDemandeByCode(code ?? ""),
    queryFn: async () => {
      if (!code) return null;
      const response = await api.get(API_ENDPOINTS.ETAT_DEMANDES, {
        params: { code },
      });
      const items = response.data.member || response.data;
      return Array.isArray(items) ? items[0] : items;
    },
    enabled: !!code,
    staleTime: 1000 * 60 * 60 * 24,
    gcTime: 1000 * 60 * 60 * 24 * 7,
  });
}
